import { render, staticRenderFns } from "./AvatarBasic.vue?vue&type=template&id=248dbe9f&"
import script from "./AvatarBasic.vue?vue&type=script&lang=ts&"
export * from "./AvatarBasic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports